import { FC } from "react";
import { Link } from "react-router-dom";
import { PostProperty } from "../../../constants";
import { HeaderType } from "../../../types/Layout";
import { routes } from "../../../routers/routes";
import AccountMenu from "./AccountMenu";
import JobApply from "./JobApply";

const UserActions: FC<HeaderType> = ({ part, isJobOrProperty }) => {
  return (
    <div className="right-side-header">
      <JobApply part={part} />
      {part?.includes("property") && (
        <Link to={routes.Pages.Other.UserDashboard} className="btn-solid">
          {PostProperty}
        </Link>
      )}
      {!isJobOrProperty && <AccountMenu part={part} />}
    </div>
  );
};

export default UserActions;